import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function GetDdsByUuids() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1">
        Retrieves information for up to 100 DDS statements using UUIDs from successful submissions.<br/>
        Returns official identifiers and current status. Requires exact UUID matches.<br/>
        Supports GET and POST requests.
      </Typography>
      
      <Typography variant="h6" sx={{   mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="GET /api/eudr/dds/info?uuids={uuid1},{uuid2},{uuid3},..." />

      <CodeBlock code="POST /api/eudr/dds/info" />

      <Typography variant="h6" sx={{   mt: 2 }}>
        Request Body (<small>POST</small>)
      </Typography>
      <CodeBlock 
        code={`{
    "uuids": [
        "97800d7b-bff7-4fd8-83a6-ea71a32fb710",
        "62ff83cd-524d-4477-a469-42406a58dced"
    ]
}`} 
      />

      <Typography variant="h6" sx={{   mt: 2 }}>
        Response
      </Typography>
      <CodeBlock 
        code={`{
    "status": "success",
    "httpStatus": 200,
    "data": [
        {
            "identifier": "62ff83cd-524d-4477-a469-42406a58dced",
            "internalReferenceNumber": "FR-000002",
            "status": "SUBMITTED",
            "date": "2025-03-19T21:28:33.000Z",
            "updatedBy": "Pavel Kovačić"
        },
        {
            "identifier": "97800d7b-bff7-4fd8-83a6-ea71a32fb710",
            "internalReferenceNumber": "FR-000002",
            "status": "CANCELLED",
            "date": "2025-03-19T20:12:40.000Z",
            "updatedBy": "Pavel Kovačić"
        }
    ]
}`} 
      />

      <Typography variant="h6" sx={{   mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>200</TableCell>
              <TableCell>Request successful</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>404</TableCell>
              <TableCell>One or more statements not found</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" sx={{   mt: 2 }}>
        Key Features
      </Typography>
      <ul>
        <li><Typography variant="body2">Max 100 UUIDs per request</Typography></li>
        <li><Typography variant="body2">Returns internal reference numbers for cross-reference</Typography></li>
        <li><Typography variant="body2">Status indicators: Available/Expired/Withdrawn</Typography></li>
      </ul>
    </Box>
  );
}

export default GetDdsByUuids; 